var _defs, _g, _rect, _path, _circle, _path2, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 157 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.5;}.cls-2{fill:#b3ddee;}.cls-2,.cls-3,.cls-4{stroke:#0090b9;stroke-miterlimit:10;stroke-width:2px;}.cls-3{fill:#fff;}.cls-4{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.84,
    y: 62.41,
    width: 101,
    height: 50.96,
    rx: 3.46,
    transform: "translate(33.08 -19.88) rotate(19.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.89,85.16,36.59,63a7.69,7.69,0,0,0,9.73-4.76l69.24,24.09a7.6,7.6,0,0,0,4.69,9.7l-7.73,22.2a7.62,7.62,0,0,0-9.7,4.69L33.58,94.85A7.61,7.61,0,0,0,28.89,85.16Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 74.57,
    cy: 88.61,
    r: 15.19,
    transform: "translate(-21.73 152.94) rotate(-83.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.31,98.25a14.33,14.33,0,0,1-2.94-1.39,8.22,8.22,0,0,1-1.72-1.46l.71-.89A9.61,9.61,0,0,0,69.14,96a11.89,11.89,0,0,0,2.55,1.2l2.6-7.46c-.45-.36-1-.8-1.51-1.26a7.38,7.38,0,0,1-1.25-1.51,5.14,5.14,0,0,1-.68-1.78,4.13,4.13,0,0,1,.23-2.1,4.37,4.37,0,0,1,.85-1.48,3.68,3.68,0,0,1,1.37-1,4.8,4.8,0,0,1,1.85-.39,6.52,6.52,0,0,1,2.33.37l.86-2.45,1,.36-.85,2.45a14.37,14.37,0,0,1,2.1,1.1,8.39,8.39,0,0,1,1.5,1.26l-.64.79A7.43,7.43,0,0,0,80,82.89,15.59,15.59,0,0,0,78.14,82l-2.51,7.2c.44.39,1,.85,1.54,1.3a6.75,6.75,0,0,1,1.24,1.41,4.27,4.27,0,0,1,.64,1.65,4,4,0,0,1-.23,2,5,5,0,0,1-1,1.74,4.43,4.43,0,0,1-1.51,1.07,5.12,5.12,0,0,1-1.85.43,9,9,0,0,1-2.08-.2l-.91,2.6-1-.36Zm.92-14.72A3.24,3.24,0,0,0,72,85a3.19,3.19,0,0,0,.44,1.24,5.19,5.19,0,0,0,.92,1.13c.39.36.87.75,1.32,1.13l2.39-6.88a5.36,5.36,0,0,0-3.17,0A3.06,3.06,0,0,0,72.23,83.53Zm5.39,11.56a3.16,3.16,0,0,0,.19-1.53,2.9,2.9,0,0,0-.49-1.23,4.87,4.87,0,0,0-.92-1c-.38-.32-.72-.62-1.18-1l-2.47,7.12a5.2,5.2,0,0,0,3-.15A3.32,3.32,0,0,0,77.62,95.09Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.47,
    y: 60.6,
    width: 101,
    height: 50.96,
    rx: 3.46,
    transform: "translate(1.41 -1.22) rotate(0.93)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31,98l.38-23.43A7.68,7.68,0,0,0,39.13,67l73.3,1.19A7.62,7.62,0,0,0,119.92,76l-.38,23.5a7.63,7.63,0,0,0-7.74,7.5l-73.3-1.2A7.62,7.62,0,0,0,31,98Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 75.46,
    cy: 87,
    r: 15.19,
    transform: "translate(-16.34 17.47) rotate(-11.92)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.39,97.17a13.72,13.72,0,0,1-3.22-.39,8.38,8.38,0,0,1-2.1-.85l.39-1.07a9.45,9.45,0,0,0,2.15.81,11.44,11.44,0,0,0,2.8.35l.13-7.91c-.54-.19-1.22-.44-1.83-.72a7.17,7.17,0,0,1-1.66-1,5,5,0,0,1-1.2-1.48,4,4,0,0,1-.44-2.06,4.58,4.58,0,0,1,.34-1.68,3.72,3.72,0,0,1,1-1.39,4.6,4.6,0,0,1,1.64-.95,6.6,6.6,0,0,1,2.33-.39l0-2.59,1.09,0,0,2.59a14.78,14.78,0,0,1,2.34.39,8.4,8.4,0,0,1,1.82.72l-.36,1a7.34,7.34,0,0,0-1.79-.61,18.88,18.88,0,0,0-2-.3l-.12,7.62c.54.23,1.25.49,1.87.75a6.8,6.8,0,0,1,1.62,1,4.21,4.21,0,0,1,1.12,1.36,3.91,3.91,0,0,1,.41,2,5.09,5.09,0,0,1-.42,2,4.29,4.29,0,0,1-1.1,1.49,5,5,0,0,1-1.62,1,8.71,8.71,0,0,1-2,.46l0,2.76-1.09,0ZM71.65,82.91a3.21,3.21,0,0,0,.27,1.45,3.33,3.33,0,0,0,.8,1,5,5,0,0,0,1.23.78c.49.23,1.07.45,1.61.66l.12-7.28a5.37,5.37,0,0,0-3,1A3.09,3.09,0,0,0,71.65,82.91Zm8.74,9.29a3.13,3.13,0,0,0-.3-1.51,3,3,0,0,0-.84-1,4.81,4.81,0,0,0-1.2-.68c-.47-.19-.88-.37-1.42-.55L76.51,96a5.22,5.22,0,0,0,2.77-1.07A3.31,3.31,0,0,0,80.39,92.2Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 77.35,
    cy: 80.33,
    r: 66.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step3.28c89a625051a96954ddf8a4c3635da0.svg";
export { ForwardRef as ReactComponent };